const domainName = "https://mp-premium-server.vercel.app/";
const serverUrl = "https://mp-premium-server.vercel.app/";

export { domainName, serverUrl };
